import { render } from "./SheetSongModal.vue?vue&type=template&id=2ade89d0"
import script from "./SheetSongModal.vue?vue&type=script&lang=js"
export * from "./SheetSongModal.vue?vue&type=script&lang=js"

import "./SheetSongModal.vue?vue&type=style&index=0&id=2ade89d0&lang=css"
script.render = render

export default script